<template>
  <!-- start of navbar design -->
  <div class="navbar">
    <!-- brand design -->
    <div class="flexNav flexStart">
      <SearchBar />
    </div>

    <div class="flexNav">
      <router-link
        class="navHome navCenter"
        :class="{
          onHome: onMessageBoard,
        }"
        :to="{
          name: 'MessageBoard',
          params: {
            name: this.groupName.replace(/\s/g, '-'),
            id: this.groupId,
            type: this.groupType,
          },
        }"
      >
        <p class="subtitle">Home</p>
        <div :class="{ navUnderline: onMessageBoard }"></div>
      </router-link>
      <router-link
        class="addChatButtonNav navCenter"
        :class="{
          onFinder: onFinder,
        }"
        :to="{
          name: 'AddCourse',
        }"
      >
        <p class="subtitle">Courses</p>
        <div :class="{ navUnderline: onFinder }"></div>
      </router-link>

      <router-link
        class="navDiscover navCenter"
        :class="{
          onDiscover: onDiscover,
        }"
        :to="{
          name: 'Discover',
        }"
      >
        <p class="subtitle">Discover</p>
        <div :class="{ navUnderline: onDiscover }"></div>
      </router-link>
      <!--button @click="uploadCourseToDb()">hello</button-->
      <!--button @click="checkRequested()">check</button-->
    </div>

    <!--profile design -->
    <div class="flexNav flexEnd">
      <button class="navAdditional smallNav" @click="setAdditional()"></button>
      <button
        class="navNotification smallNav"
        @click="setNotification()"
      ></button>
      <router-link
        class="navProfile"
        :to="{
          name: 'Profile',
        }"
      >
        <img
          :src="this.user.profileImage"
          class="rightSidePic"
          width="58"
          height="58"
        />
      </router-link>
    </div>

    <div v-if="onAdditional" id="additionalPopup">
      <router-link
        class="additionalButton"
        :to="{
          name: 'Profile',
          params: { schoolName: this.user.schoolName },
        }"
      >
        <img class="navProfile" :src="this.user.profileImage" />
        <p>{{ this.user.firstName }} {{ this.user.lastName }}</p>
      </router-link>
      <!--
      <div class="additionalButton">
        <div class="additionalImg">
          <img src="@/assets/additionalFeedback.svg" />
        </div>
        Feedback
      </div>
      <div class="additionalButton">
        <div class="additionalImg">
          <img src="@/assets/additionalHelp.svg" />
        </div>
        Help and support
      </div>
      -->
      <div class="additionalButton" v-if="isAmbassador" @click="goToPortal">
        <div class="additionalImg">
          <img src="@/assets/additionalPortal.svg" />
        </div>
        Portal
      </div>
      <div class="additionalButton" @click="goToSettings">
        <div class="additionalImg">
          <img src="@/assets/additionalSettings.svg" />
        </div>
        Settings
      </div>
      <div class="additionalButton" v-if="isAdmin" @click="goToAnalytics">
        <div class="additionalImg">
          <img src="@/assets/additionalAnalytics.svg" />
        </div>
        Analytics
      </div>
      <div class="additionalButton" @click="logout">
        <div class="additionalImg">
          <img src="@/assets/additionalLogout.svg" />
        </div>
        Logout
      </div>
    </div>

    <div
      v-if="onNotification"
      id="additionalPopup"
      :class="{ isWindow: isWindows }"
    >
      <p class="headerText">Notifications</p>
      <div class="notificationOptionRow">
        <div
          class="notificationOption"
          :class="currentNotif == 'all' ? 'bottomBorder' : ''"
          @click="toggleNotif('all')"
        >
          All
        </div>
        <div
          class="notificationOption"
          :class="currentNotif == 'upcoming' ? 'bottomBorder' : ''"
          @click="toggleNotif('upcoming')"
        >
          Events
        </div>
        <div
          class="notificationOption"
          :class="currentNotif == 'link' ? 'bottomBorder' : ''"
          @click="toggleNotif('link')"
        >
          Friends
        </div>
        <div
          class="notificationOption"
          :class="currentNotif == 'groups' ? 'bottomBorder' : ''"
          @click="toggleNotif('groups')"
        >
          Groups
        </div>
      </div>
      <div class="notificationColumn">
        <template v-if="currentNotif == 'all'">
          <template v-if="linkRequests.length > 0 || groupRequests.length > 0">
            <p class="notifSubtitle">Requests</p>
            <div
              class="listNotification"
              v-for="(user, index) in linkRequests"
              :key="index"
            >
              <Request :addUser="user" :requests="linkRequests" />
            </div>
            <div
              class="listNotification"
              v-for="(group, index) in groupRequests"
              :key="index"
            >
              <GroupInvite :group="group" :requests="groupRequests" />
            </div>
          </template>
          <template v-if="upcomingEvents.length > 0">
            <p>Calendar Events</p>
            <div
              class="listNotification"
              v-for="(event, index) in upcomingEvents"
              :key="index"
            >
              <div v-if="event.type == 'Calendar'">
                <Upcoming
                  :title="event.title"
                  :line1="event.startDate + ' - ' + event.endDate"
                  :line2="event.daysLeft"
                  :color="event.color"
                />
              </div>
            </div>
          </template>
          <div
            v-if="
              !linkRequests.length &&
                !groupRequests.length &&
                !upcomingEvents.length
            "
            class="emptyNotifContainer"
          >
            <img class="emptyNotif" src="../assets/emptyNotifications.png" />
            <p class="emptyNotifText">
              Woohoo! You've already checked all your notifications!
            </p>
          </div>
        </template>
        <template v-else-if="currentNotif == 'upcoming'">
          <div
            class="listNotification"
            v-for="(event, index) in upcomingEvents"
            :key="index"
          >
            <Upcoming
              :title="event.title"
              :line1="event.startDate + ' - ' + event.endDate"
              :line2="event.daysLeft"
              :color="event.color"
            />
          </div>
          <div v-if="!upcomingEvents.length" class="emptyNotifContainer">
            <img class="emptyNotif" src="../assets/emptyNotifications.png" />
            <p class="emptyNotifText">
              Seems like you don't have any upcoming events!
            </p>
          </div>
        </template>
        <template v-else-if="currentNotif == 'link'">
          <div
            class="listNotification"
            v-for="(user, index) in linkRequests"
            :key="index"
          >
            <Request :addUser="user" :requests="linkRequests" />
          </div>
          <div v-if="!linkRequests.length" class="emptyNotifContainer">
            <img class="emptyNotif" src="../assets/emptyNotifications.png" />
            <p class="emptyNotifText">
              No friend requests
            </p>
          </div>
        </template>
        <template v-else-if="currentNotif == 'groups'">
          <div
            class="listNotification"
            v-for="(group, index) in groupRequests"
            :key="index"
          >
            <GroupInvite :group="group" :requests="groupRequests" />
          </div>
          <div v-if="!groupRequests.length" class="emptyNotifContainer">
            <img class="emptyNotif" src="../assets/emptyNotifications.png" />
            <p class="emptyNotifText">
              No group requests
            </p>
          </div>
        </template>
      </div>
      <!--
      <div
        class="listNotification"
        v-for="(user, index) in linkRequests"
        :key="index"
      >
        <Request :addUser="user" :requests="linkRequests" />
      </div>
      <div
        class="listNotification"
        v-for="(user, index) in user.linkRequests"
        :key="index"
      >
        <Request :addUser="user" :requests="user.linkRequests" />
      </div>
      -->
    </div>
  </div>

  <!-- end of navbar design -->
</template>

<script>
import { mapState, mapActions } from "vuex";
import db from "@/db";
import SearchBar from "@/components/SearchBar";
import Request from "@/components/profile/Request";
import GroupInvite from "@/components/profile/GroupInvite";
import Upcoming from "@/components/profile/Upcoming";

export default {
  components: {
    SearchBar,
    Request,
    GroupInvite,
    Upcoming,
  },

  data: () => ({
    onMessageBoard: false,
    onFinder: false,
    onDiscover: false,
    isWindows: false,
    onAdditional: false,
    onNotification: false,
    searchString: "",
    linkRequests: [],
    groupRequests: [],
    upcomingEvents: [],
    currentNotif: "all",
    isAmbassador: false,
    isAdmin: false,
  }),

  computed: {
    ...mapState("messageBoard", ["groupName", "groupId", "groupType"]),
    ...mapState("user", ["user"]),
  },
  created() {
    this.isWindows = this.checkOS();
    this.checkPage();
    this.checkAmbassador();
  },
  mounted() {},
  methods: {
    ...mapActions("user", ["logout"]),
    ...mapActions("groupInfo", ["getGroupType"]),
    checkOS() {
      if (navigator.appVersion.indexOf("Win") != -1) {
        return true;
      }
      return false;
    },
    // checkAmbassador() {
    //isAmbassador
    //   db.collection("ambassadors");
    // },
    checkAmbassador() {
      db.collection("ambassadorInfo")
        .doc(this.user.id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.isAmbassador = true;
          }
          //Victorien, Nick, Abe, Seb, Max, Aritra, Timur
          var listOfAdmins = [
            "WiWStp1xL6gGapCuviEXP6L7CAi2",
            "7Ub5bzzb1JNC1sjW0RMywcoNftr2",
            "dbUmJv0xBjYoZ7LLziTyPojPUeO2",
            "6Su0tIk0BMSyQzjCOPlWV8CPmfZ2",
            "U51Kw09il4ME4T8n8MZC4evSirL2",
            "sOzn66KRLZZPGNBScf3YfyAz3c33",
            "HXcmzIcBmLM3div6QOsQtDHv5eA3",
          ];
          if (listOfAdmins.includes(this.user.id)) {
            this.isAdmin = true;
          }
        });
    },
    goToPortal() {
      this.$router.push({
        name: "Portal",
      });
    },
    goToSettings() {
      this.$router.push({
        name: "Settings",
      });
    },
    goToAnalytics() {
      this.$router.push({
        name: "Analytics",
      });
    },
    checkPage() {
      if (this.$route.name == "MessageBoard") {
        this.onMessageBoard = true;
      } else if (this.$route.name == "Discover") {
        this.onDiscover = true;
      } else if (this.$route.name == "AddCourse") {
        this.onFinder = true;
      }
    },
    toggleNotif(current) {
      this.currentNotif = current;
    },
    setMessageBoard() {
      this.$store.commit("mainPage/setMessageBoard");
    },
    toAddCourse() {
      this.onMessageBoard = false;
    },
    async checkRequested() {
      await db
        .collection("missingCourses")
        .get()
        .then(async (querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log(doc.course);
          });
        });
    },
    clearUni() {
      db.collection("courses")
        .where("school_id", "==", "AHFxac59JNf63I3PlelQ")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            doc.ref.delete();
          });
        });
      console.log("DONE COURSES");

      db.collection("subjects")
        .where("school_id", "==", "AHFxac59JNf63I3PlelQ")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            doc.ref.delete();
          });
        });

      console.log("DONE SUBJECTS");
    },
    addInfo(initialName) {
      var letters = [];
      var some_letters = [];
      var numbers = [];
      var courseCode = "";
      var courseWords = [];
      var subject = "";
      var courseName = initialName.split(/(?: )+/); //-|
      var foundCode = false;
      for (var w = 0; w < courseName.length; w++) {
        //FOR UCHICAGO AND UILLINOIS
        /*if (w == 0) {
          foundCode = true;
          var courseNameAndCode = courseName[0].split(/\u00A0/);
          courseWords.push(courseNameAndCode[0]);
          courseCode = courseNameAndCode[1];
        } else if (foundCode) {
          var tempSubject = subject;
          if (subject.length == 0) {
            subject = tempSubject.concat(courseName[w]);
          } else {
            subject = tempSubject.concat(" ", courseName[w]);
          }
        } else {
          courseWords.push(courseName[w]);
        }*/
        //NORMAL CODE (2 words, only chars in first, numbs in second)
        /*if (/\d/.test(courseName[w])) {
          foundCode = true;
          courseCode = courseName[w];
        } else if (foundCode) {
          var tempSubject = subject;
          if (subject.length == 0) {
            subject = tempSubject.concat(courseName[w]);
          } else {
            subject = tempSubject.concat(" ", courseName[w]);
          }
        } else {
          courseWords.push(courseName[w]);
        }*/
        //UOFT (1 word)
        if (/\d/.test(courseName[w])) {
          foundCode = true;
          courseCode = "";
          courseWords.push(courseName[w]);
        } else if (foundCode) {
          var tempSubject = subject;
          if (subject.length == 0) {
            subject = tempSubject.concat(courseName[w]);
          } else {
            subject = tempSubject.concat(" ", courseName[w]);
          }
        } else {
          courseWords.push(courseName[w]);
        }
        //UREGINA and MCGILL+ (two word course codes, nums in either-or)
        /*if (w == 1) {
          foundCode = true;
          courseCode = courseName[w];
        } else if (foundCode) {
          var tempSubject = subject;
          if (subject.length == 0) {
            subject = tempSubject.concat(courseName[w]);
          } else {
            subject = tempSubject.concat(" ", courseName[w]);
          }
        } else {
          courseWords.push(courseName[w]);
        }*/
      }
      //list of keywords for individual words
      for (var i = 0; i < courseWords.length; i++) {
        var word = courseWords[i];
        for (var l = 1; l < word.length + 1; l++) {
          some_letters.push(word.substring(0, l).toLowerCase());
        }
      }
      //keywords for number
      for (var j = 1; j < courseCode.length + 1; j++) {
        numbers.push(courseCode.substring(0, j).toLowerCase());
      }
      var newName = "";
      newName = courseWords.toString().concat(" ", courseCode.toString());
      //keywords for total name
      for (var k = 1; k < newName.length + 1; k++) {
        letters.push(newName.substring(0, k).toLowerCase());
      }
      letters = some_letters.concat(letters);
      letters = letters.filter((v, i, a) => a.indexOf(v) === i);
      // UOFT
      var dict = {
        CODE: courseWords,
        LETTERS: letters,
        NUMBERS: "",
        SUBJECT: subject,
      };

      /*var dict = {
        CODE: some_letters[some_letters.length - 1]
          .toUpperCase()
          .concat(" ", numbers[numbers.length - 1].toUpperCase()),
        LETTERS: letters,
        NUMBERS: numbers,
        SUBJECT: subject,
      };*/

      return dict;
    },
    async uploadCourseToDb() {
      console.log("CLICKED");
      var courses = [];
      var subject_list = [];
      for (const index in courses) {
        var current = courses[index];
        var courseImage = "";

        //console.log(this.addInfo(courses[index]));
        if (
          current.includes("Bio") ||
          current.includes("Botany") ||
          current.includes("Forest") ||
          current.includes("Agriculture") ||
          current.includes("Wood")
        ) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultPlant.png?alt=media&token=5ff85334-b76d-48c3-942e-03148c13bba0";
        } else if (
          current.includes("Computer") ||
          current.includes("Software")
        ) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultCode.png?alt=media&token=9954e690-d171-4594-8128-ad77aa7014d3";
        } else if (current.includes("Literature")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultBook.png?alt=media&token=fcb9a1b7-64bc-4122-8da8-826539a3b236";
        } else if (current.includes("Chemistry")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultChemistry.png?alt=media&token=dce8ef31-dc85-4af8-9c9a-b252d2901083";
        } else if (current.includes("Music")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultMusic.png?alt=media&token=fe148d60-9b8f-4aaf-ab93-76910afc0106";
        } else if (current.includes("Sport")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultSoccer.png?alt=media&token=abc4831c-a5a1-459f-8622-5fda2782d4fd";
        } else if (current.includes("Art") || current.includes("Writing")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultSign.png?alt=media&token=96fd0a2e-139d-4435-b99f-7d39a1454770";
        } else if (current.includes("Energy") || current.includes("Engineer")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultGear.png?alt=media&token=85ac51df-e8b5-45d8-b42e-db2bf2d78518";
        } else if (
          current.includes("Commerce") ||
          current.includes("Data") ||
          current.includes("Economics") ||
          current.includes("Statistic") ||
          current.includes("Account") ||
          current.includes("Math") ||
          current.includes("Business")
        ) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultGraph.png?alt=media&token=0c7fc347-575d-4cc9-b3cd-b51b3f177424";
        } else if (current.includes("Education") || current.includes("Learn")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultEducation.png?alt=media&token=87673eca-c45b-40fe-b80a-7a0a4ffc1f19";
        } else if (current.includes("Food")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultCake.png?alt=media&token=7e198e47-6a77-464b-aaa3-8d20bbf9473a";
        } else if (current.includes("Geography")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultMountain.png?alt=media&token=911f0fd3-073a-4115-92b3-6e6875b07654";
        } else if (current.includes("Journalism")) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultPostit.png?alt=media&token=3c6f28a5-719b-4d88-a5cd-d0d74009e56e";
        } else if (
          current.includes("Kinesiology") ||
          current.includes("Health") ||
          current.includes("Surgery")
        ) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultHeart.png?alt=media&token=cef41f31-d588-40e2-b56d-f33391845a03";
        } else if (
          current.includes("Act") ||
          current.includes("Theatre") ||
          current.includes("Theater") ||
          current.includes("Film")
        ) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultAct.png?alt=media&token=3fd35c79-5d93-41f1-9d45-4054916dea0f";
        } else if (
          current.includes("Histor") ||
          current.includes("Anthropology") ||
          current.includes("Cultur")
        ) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultHistory.png?alt=media&token=0a61c5a4-2d4d-4720-8c9f-894beb4f2ab0";
        } else if (
          current.includes("Language") ||
          current.includes("English") ||
          current.includes("French") ||
          current.includes("German") ||
          current.includes("Spanish") ||
          current.includes("Chinese") ||
          current.includes("Mandarin") ||
          current.includes("Hindi") ||
          current.includes("Arabic") ||
          current.includes("Russian") ||
          current.includes("Bengali") ||
          current.includes("Malay") ||
          current.includes("Italian") ||
          current.includes("Portuguese")
        ) {
          courseImage =
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultTalk.png?alt=media&token=ec306870-197b-4ecd-b21e-f5b107175bb6";
        } else {
          var imgList = [
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultBook.png?alt=media&token=fcb9a1b7-64bc-4122-8da8-826539a3b236",
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultCourselnk.png?alt=media&token=100b4b81-8e89-42fc-95af-c11398a25d",
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultPostit.png?alt=media&token=3c6f28a5-719b-4d88-a5cd-d0d74009e56e",
            "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultGroupImages%2FdefaultSign.png?alt=media&token=96fd0a2e-139d-4435-b99f-7d39a1454770",
          ];
          var randomNum = Math.floor(Math.random() * 4);
          courseImage = imgList[randomNum];
        }

        var courseInfo = this.addInfo(courses[index]);

        if (!subject_list.includes(courseInfo.SUBJECT)) {
          subject_list.push(courseInfo.SUBJECT);
        }

        var course = {
          name: courseInfo.CODE[0], //add [0] for UofT, remove for others
          subject: courseInfo.SUBJECT,
          school_id: "6StICCPUC4vEQD8LzAto",
          hasSeenLastPost: [],
          users: [],
          profileImage: courseImage,
          letterKeywords: courseInfo.LETTERS,
          numberKeywords: courseInfo.NUMBERS,
          recentPosts: [],
        };

        //check if course exists (REMOVE FOR NEW UNIS)
        await db
          .collection("courses")
          .where("school_id", "==", "6StICCPUC4vEQD8LzAto")
          .where("name", "==", course.name)
          .get()
          .then(async (querySnapshot) => {
            var i = 0;
            //console.log(querySnapshot.data());
            querySnapshot.forEach((doc) => {
              if (doc == null) {
                i = 0;
              }
              i++;
            });
            if (i == 0) {
              db.collection("courses")
                .doc()
                .set(course);
              console.log(course.name);
            }
          });
        //db.collection("courses")
        //  .doc()
        //  .set(course);

        console.log("COURSES");
      }

      //this.uploadSubjectsToDb(subject_list);
      console.log("DONE");
    },

    uploadSubjectsToDb(subject_list) {
      for (const index in subject_list) {
        var subject = {
          name: subject_list[index],
          school_id: "6StICCPUC4vEQD8LzAto",
        };
        console.log("SUBJECTS");
        db.collection("subjects")
          .doc()
          .set(subject);
      }
    },

    setCalendar() {
      this.$store.commit("mainPage/setCalendar");
    },
    setReview() {
      this.$store.commit("mainPage/setReview");
    },
    setUpload() {
      this.$store.commit("mainPage/setUpload");
    },
    async getName() {
      var name = await this.groupName;
      return name.replace(/\s/g, "");
    },
    creatingGroup() {
      this.$store.commit("messageBoard/setCreateGroup", true);
    },
    setAdditional() {
      this.onAdditional = !this.onAdditional;
      this.onNotification = false;
    },
    setNotification() {
      this.groupRequests = this.user.groupInvites ? this.user.groupInvites : [];
      this.onNotification = !this.onNotification;
      this.onAdditional = false;
      if (this.onNotification) {
        this.fetchRequests();
      }
    },
    fetchRequests() {
      db.collection("users")
        .doc(this.user.id)
        .get()
        .then((doc) => {
          var user = doc.data();
          this.user.groupInvites = user.groupInvites ? user.groupInvites : [];
          this.user.linkRequests = user.linkRequests ? user.linkRequests : [];
          this.$store.commit("user/setUser", this.user);
          this.linkRequests = [];
          this.groupRequests = user.groupInvites ? user.groupInvites : [];
          user.linkRequests.forEach((userDoc) =>
            db
              .collection("users")
              .doc(userDoc.id)
              .get()
              .then((doc) => {
                var user = doc.data();
                user.id = doc.id;
                this.linkRequests.push(user);
              })
          );
        });
    },
  },
};
</script>

<style src="@/styles/Navbar.css"></style>
